import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('embeds.events.coverage')

export function coverageText(filled: number, total: number) {
  const open = total - filled
  if (open <= 0) return t('full')
  if (open <= 2) return t('almost_full', { count: open })
  if (filled / total < 0.5) return t('volunteers_needed', { count: open })
  return t('spots_left', { count: open })
}

export function coverageBarColour(filled: number, total: number) {
  if (filled >= total) return 'tw:bg-gray-400'
  const share = filled / total
  if (share < 0.34) return 'tw:bg-error-500'
  if (share < 0.67) return 'tw:bg-warning-500'
  return 'tw:bg-success-500'
}
